import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="max-w-3xl mx-auto px-6 py-12" data-id="element-94">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-95">
        <div className="w-full md:w-1/2 relative" data-id="element-96">
          <div className="bg-white p-3 pb-10 rounded-sm shadow-xl rotate-[-2deg] border border-stone-200" data-id="element-97">
            <div className="aspect-[4/5] bg-stone-100 overflow-hidden relative" data-id="element-98">
              <img src="https://cdn.magicpatterns.com/uploads/aGVvE4rjuzZQV4V5VYF8Qj/Magen_Darm_4f46689c-206a-426f-9344-0505df3c965a.webp" alt="Hunderunde Futtertopping Magen & Darm Verpackung" className="w-full h-full object-cover" data-id="element-99" />
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/2 space-y-4" data-id="element-100">
          <h2 className="text-2xl sm:text-3xl font-bold text-brand-brown font-sans" data-id="element-101">
            Was ich bestellt habe
          </h2>
          <div className="w-12 h-1 bg-brand-amber rounded-full mb-6" data-id="element-102"></div>
          <p className="text-lg text-stone-700 font-serif leading-relaxed" data-id="element-103">
            Das Magen-Darm-Topping von Hunderunde. Ich habe es bestellt, weil es
            als einziges Produkt keine künstlichen Zusatzstoffe enthält und
            speziell für empfindliche Hunde entwickelt wurde.
          </p>
        </div>
      </motion.div>
    </section>;
}